import styled from "styled-components/macro";

export const Version = styled.span`
position: absolute;
bottom: 75px;
right: 15px;
`;
